/* mimi 用の横スクロールスライダー。スクロールスナップ + 矢印 + ドット。 */
(() => {
  const init = (root) => {
    const track = root.querySelector('[data-sk-track]');
    if (!track) return;
    const allSlides = Array.from(track.children);
    const prev = root.querySelector('[data-sk-prev]');
    const next = root.querySelector('[data-sk-next]');
    const allDots = Array.from(root.querySelectorAll('[data-sk-dot]'));
    if (!allSlides.length) return;

    // PCのヒーローが横長表示のとき、横長画像の無いスライド（とそのドット）は
    // CSSで隠れている（2026-09-25）。位置の計算は見えているものだけで行う。
    // 画面幅で見える枚数が変わるので、その都度数え直す
    const shown = (list) => list.filter((el) => el.offsetWidth > 0);
    let slides = allSlides;
    let dots = allDots;
    const refresh = () => {
      slides = shown(allSlides);
      dots = shown(allDots);
      if (!slides.length) slides = allSlides;
    };
    refresh();
    window.addEventListener('resize', refresh);

    const step = () => slides[0].getBoundingClientRect().width;

    // スライドの揃え位置はCSSの scroll-snap-align で決まる（PCのヒーローは start・2026-09-24）。
    // start のときは「左端に来ているスライド」を現在位置とみなし、送るときも左端に合わせる
    const isStart = () => getComputedStyle(slides[0]).scrollSnapAlign.split(' ')[0] === 'start';
    const padLeft = () => parseFloat(getComputedStyle(track).paddingLeft) || 0;

    const maxScroll = () => track.scrollWidth - track.clientWidth;
    const targetOf = (s) => s.offsetLeft - padLeft();

    // start揃えでは後ろの数枚が左端まで来られない（右端で止まる）ので、
    // 送る先は「スライドの位置」ではなく「今のスクロール位置より先／手前の次の候補」で決める
    const stepStart = (dir) => {
      const cur = track.scrollLeft;
      const targets = slides.map((s) => Math.min(Math.max(0, targetOf(s)), maxScroll()));
      const t = dir > 0 ? targets.find((x) => x > cur + 2) : targets.slice().reverse().find((x) => x < cur - 2);
      if (t !== undefined) track.scrollTo({ left: t, behavior: 'smooth' });
    };

    const currentIndex = () => {
      const start = isStart();
      if (start && track.scrollLeft >= maxScroll() - 2 && maxScroll() > 0) return slides.length - 1;
      const center = start ? track.scrollLeft + padLeft() : track.scrollLeft + track.clientWidth / 2;
      let best = 0;
      let bestDist = Infinity;
      slides.forEach((s, i) => {
        const c = start ? s.offsetLeft : s.offsetLeft + s.offsetWidth / 2;
        const d = Math.abs(c - center);
        if (d < bestDist) {
          bestDist = d;
          best = i;
        }
      });
      return best;
    };

    const goTo = (i) => {
      const idx = Math.max(0, Math.min(slides.length - 1, i));
      const s = slides[idx];
      track.scrollTo({
        left: isStart() ? s.offsetLeft - padLeft() : s.offsetLeft - (track.clientWidth - s.offsetWidth) / 2,
        behavior: 'smooth',
      });
    };

    const sync = () => {
      const i = currentIndex();
      dots.forEach((d, n) => d.setAttribute('aria-current', n === i ? 'true' : 'false'));
    };

    prev?.addEventListener('click', () => {
      if (isStart()) stepStart(-1);
      else if (dots.length) goTo(currentIndex() - 1);
      else track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next?.addEventListener('click', () => {
      if (isStart()) stepStart(1);
      else if (dots.length) goTo(currentIndex() + 1);
      else track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    allDots.forEach((d) => d.addEventListener('click', () => goTo(dots.indexOf(d))));

    let raf = 0;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    });

    // 初期位置を最初のスライドの中央に合わせる（左右に見切れがある構成のため）
    requestAnimationFrame(() => {
      refresh();
      goTo(0);
      sync();
    });
  };

  const boot = () => document.querySelectorAll('[data-sk-slider]').forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
